// extracted by mini-css-extract-plugin
export default {"details":"MT8DC_QFuP","detail":"oxO2XHS2MB","value":"HWkzx5lTta","agreement":"jhJ1Khq4Bw","agreementText":"WQ1NfJgdUY"};